import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Vant from 'vant';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.css'
import 'vant/lib/index.css';
// 3. 注册你需要的组件

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js